import React, { forwardRef } from 'react';
import styles from './ScrollableContent.module.scss';

/**
 * @typedef {object} ScrollableContentProps
 * @property {React.ReactNode} children
 */

/**
 * @type {React.ForwardRefExoticComponent<ScrollableContentProps & React.RefAttributes<HTMLParagraphElement>>}
 * @param {ScrollableContentProps} props
 */
export const ScrollableContent = forwardRef((props, ref) => {
  const { children } = props;

  return (
    <p ref={ref} className={styles.content} tabIndex={0}>
      {children}
    </p>
  );
});

ScrollableContent.displayName = 'ScrollableContent';
